import updateIneConfirmationModal from './update-ine-confirmation-modal.json';

export default {
  'update-ine': {
    ...updateIneConfirmationModal,
  },
};
